<script>
    import CRUD from './CRUD.svelte';
    import { fetchVehiculos, saveVehiculo, removeVehiculo, searchVehiculos, subscribeToVehiculos, unsubscribeFromVehiculos } from '../controllers/vehiculoController.js';
    import { t } from 'svelte-i18n';

    // Configuración de las columnas para la tabla de vehículos
    let vehiculoColumns = [
      { label: 'Placa', field: 'placa', type: 'text' },
      { label: 'Marca', field: 'marca', type: 'text' },
      { label: 'Modelo', field: 'modelo', type: 'text' },
      { label: 'Año', field: 'anio', type: 'number' },
      { label: $t('fields.state'), field: 'sta', type: 'bool' },
    ];

    // Estructura del nuevo objeto Vehiculo
    let newVehiculo = {
      placa: '',
      marca: '',
      modelo: '',
      anio: '',
      color: '',
      tipo: '',
      responsable: '',
      kilometraje: '',
      sta: true,
    };

    let tiposVehiculo = [
        { key: 'automovil', value: 'Automóvil' },
        { key: 'motocicleta', value: 'Motocicleta' },
        { key: 'camion', value: 'Camión' },
        { key: 'pickup', value: 'Pickup' },
        { key: 'bus', value: 'Autobús' },
        { key: 'maquinaria', value: 'Maquinaria Pesada' }
    ];

    // Configuración de los campos para la edición de vehículos
    let editColumns = [
        { label: 'Placa', key: 'placa', type: 'text', required: true },
        { label: 'Marca', key: 'marca', type: 'text', required: true },
        { label: 'Modelo', key: 'modelo', type: 'text', required: true },
        { label: 'Año', key: 'anio', type: 'number', required: true },
        { label: 'Color', key: 'color', type: 'text', required: true },
        { label: 'Tipo', key: 'tipo', type: 'select', options: tiposVehiculo, required: true },
        { label: 'Responsable', key: 'responsable', type: 'text', required: true },
        { label: 'Kilometraje', key: 'kilometraje', type: 'text', required: true },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox', required: true }
    ];
</script>

<CRUD 
    title={$t('entities.vehiculos')}
    entityName="vehiculo"
    newEntity={newVehiculo}
    columns={vehiculoColumns}
    fetchEntities={fetchVehiculos}
    saveEntity={saveVehiculo}
    removeEntity={removeVehiculo}
    searchEntities={searchVehiculos}
    subscribeToChanges={subscribeToVehiculos}
    unsubscribeFromChanges={unsubscribeFromVehiculos}
    editColumns={editColumns}
/>